// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3NylT","buttons":"SendReceipts_buttons__2mhvz","email":"SendReceipts_email__2X4PF","bookApptTitle":"SendReceipts_bookApptTitle__EsP-5"};